import { Download, Link, Send, Share2 } from "lucide-react";
import type { CheckResponseData } from "@handlequest/shared";
import { shareCardUrl } from "../lib/api";

interface ShareActionsProps {
  result: CheckResponseData;
}

export function ShareActions({ result }: ShareActionsProps) {
  const pageUrl = `${window.location.origin}/check/${encodeURIComponent(result.username)}`;
  const imageUrl = shareCardUrl(result.username, result.summary.available, result.summary.total);
  const text = `${result.username} is available on ${result.summary.available}/${result.summary.total} gaming platforms.`;

  return (
    <div className="share-actions" aria-label="Share scan">
      <button className="ghost-button compact" type="button" onClick={() => void navigator.clipboard?.writeText(pageUrl)}>
        <Link aria-hidden="true" />
        Copy link
      </button>
      <a className="ghost-button compact" href={imageUrl} download={`handlequest-${result.username}.svg`}>
        <Download aria-hidden="true" />
        Card
      </a>
      <a className="ghost-button icon-only" href={`https://twitter.com/intent/tweet?${new URLSearchParams({ text, url: pageUrl }).toString()}`} target="_blank" rel="noreferrer" aria-label="Share on X">
        <Send aria-hidden="true" />
      </a>
      <a className="ghost-button icon-only" href={`https://www.facebook.com/sharer/sharer.php?${new URLSearchParams({ u: pageUrl }).toString()}`} target="_blank" rel="noreferrer" aria-label="Share on Facebook">
        <Share2 aria-hidden="true" />
      </a>
    </div>
  );
}
